import { withSearch } from '@elastic/react-search-ui';
import DateRangeFilters from '../../../components/filter/DateRangeFilter';

function NHLEDocumentDateFilter({ setFilter, removeFilter, filters }) {
  return (
    <DateRangeFilters
      filters={filters}
      formHint="For example, 27 3 2007"
      fromFieldId="dateAmendedFrom"
      id="date-last-amended"
      label="Date first listed or most recent amendment"
      removeFilter={removeFilter}
      setFilter={setFilter}
      toFieldId="dateAmendedTo"
    />
  );
}

export default withSearch(({ setFilter, removeFilter, filters }) => ({
  setFilter,
  removeFilter,
  filters,
}))(NHLEDocumentDateFilter);
